angular.module("UI8.services").service("HireService", [
  "$http",
  function ($http) {
    // Rate limits answer 429 with {error} in the body — surface it
    function unwrap(promise) {
      return promise.then(
        function (res) {
          return res.data;
        },
        function (res) {
          return (res && res.data && res.data.error)
            ? res.data
            : { error: "Something went wrong. Please try again." };
        }
      );
    }

    this.createThread = function (data) {
      return unwrap($http.post("/api/hire/threads", data));
    };

    this.threads = function (page) {
      return unwrap($http.get("/api/hire/threads?page=" + (page || 1)));
    };

    this.thread = function (id) {
      return unwrap($http.get("/api/hire/threads/" + id));
    };

    this.reply = function (id, body) {
      return unwrap(
        $http.post("/api/hire/threads/" + id + "/messages", { body: body })
      );
    };

    this.block = function (id) {
      return unwrap($http.post("/api/hire/threads/" + id + "/block", {}));
    };

    this.unread = function () {
      return unwrap($http.get("/api/hire/unread"));
    };

    this.directory = function (tag) {
      return unwrap(
        $http.get(
          "/api/hire/directory" + (tag ? "?tag=" + encodeURIComponent(tag) : "")
        )
      );
    };

    /**
     * UI8 Hire subscribe: add the hire product to the cart, then send it
     * straight to hosted Stripe Checkout (never the inline arm — see
     * processor-stripe-checkout.js). Resolves {link} or {error}.
     */
    this.subscribe = function (productId) {
      var rc = window.grecaptcha;
      var rcKey = window.UI8 && UI8.recaptchaSiteKey;

      if (!rc || !rcKey) {
        return Promise.resolve({
          error:
            "Payment couldn't start — reCAPTCHA appears to be blocked. Please disable your content blocker for ui8.net and try again.",
        });
      }

      return $http
        .post("/api/cart/add", { product: productId })
        .then(function (res) {
          if (res.data && res.data.error) throw new Error(res.data.error);
          return rc.execute(rcKey, { action: "checkout" });
        })
        .then(function (token) {
          return $http.post("/api/checkout/process/stripe-checkout", {
            rcToken: token,
            idempotencyKey: UI8.idempotencyKey,
            currentUrl: window.location.href,
          });
        })
        .then(
          function (res) {
            return res.data;
          },
          function (err) {
            return {
              error:
                (err && err.message) ||
                "Unable to start checkout. Please try again.",
            };
          }
        );
    };
  },
]);
